module.exports = __webpack_public_path__ + "img/img-3-10mobile.d7c1c037.webp";